import React from "react";
import Tippy from '@tippyjs/react';
import 'tippy.js/dist/tippy.css';
import styles from "./FavoriteToggle.module.sass";

const HeartSvg = ({ filled, size = 16 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={{ display: 'inline-block', verticalAlign: 'middle' }}
  >
    {filled ? (
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 4.528a5.5 5.5 0 0 0-8 0C1.5 7.057 1.5 11.057 4 13.5l7.293 7.293a1 1 0 0 0 1.414 0L20 13.5c2.5-2.443 2.5-6.443 0-8.972a5.5 5.5 0 0 0-8 0z"
        fill="currentColor"
      />
    ) : (
      <path
        d="M12 6.5C10.614 4.5 8 3.5 6 4.5S2 8.5 3.5 11.5 12 20 12 20s7-6 8.5-8.5S18 4.5 16 4.5 13.386 4.5 12 6.5z"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
    )}
  </svg>
);

export const FavoriteInline = ({ isFavorited, onClick, size = 14 }) => (
  <Tippy content={isFavorited ? 'Remove from favorites' : 'Add to favorites'} placement="top">
    <button
      className={`${styles.inline} ${isFavorited ? styles.active : ''}`}
      onClick={(e) => { e.stopPropagation(); onClick && onClick(e); }}
      aria-label={isFavorited ? 'Remove from favorites' : 'Add to favorites'}
      type="button"
    >
      <HeartSvg filled={isFavorited} size={size} />
    </button>
  </Tippy>
);

export const FavoriteFilterButton = ({ active, onClick }) => (
  <button
    className={`${styles.filterButton} ${active ? styles.filterActive : ''}`}
    onClick={onClick}
    aria-label={active ? 'Show all' : 'Show favorites only'}
    type="button"
  >
    <HeartSvg filled={active} size={18} />
  </button>
);

export default FavoriteInline;
